import React from 'react'
import Footer from '../Footer/Footer'
import Navbar from '../Navbar/Navbar'
import "./AboutUs.css"
const AboutUs = () => {
  return (
    <div>
      <Navbar/>


  <div className="sc-3112ab3d-0 sc-98e9adb3-0 gCDmxv gGTSDy">
    <div className="sc-98e9adb3-1 hzeyLF">
      <h2
        className="sc-3112ab3d-2 ilkgnf"
        style={{ paddingTop: 10, textAlign: "start" }}
      >
        About Us
      </h2>
      <p className='about_descri f-size'>
      Kalyan, Main Bazar Jodi Chart Satta Khatri555 Record Old History Historical Data
        Bracket Results Chart Online Live Book Digits Numbers
      </p>
    </div>
  </div>
  <div className="sc-3112ab3d-0 sc-60e9ecdd-0 gCDmxv jgmYWX">
    <p  className='f-size'>
      Khatri555 is operated by S S international, a company incorporated under
      the laws of United Kingdom and regulated by the UK authority as the
      regulatory body responsible holding a (Sub-license with License number
      392/JAZ Sub-License GLH- OCCHKTV0707086017 granted on 21.08.2020).
    </p>
    <h1 className="h1-fw-600">
      Khatri555 is into existence for past 30 years with more than 1.38 lac +
      members.
    </h1>
    <p  className='f-size'>
      We have proudly taken our culture from offline to online business and now
      stand as India's most trusted betting platform. Khatri555 is an
      international betting platform and has presence in more than 18 countries.
      We truly value our customers and our endeavor is to provide best customer
      service and enable our customers to play online games with ease.
    </p>
    <span>
      <svg
        stroke="currentColor"
        fill="currentColor"
        strokeWidth={0}
        viewBox="0 0 24 24"
        height={40}
        width={40}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path fill="none" d="M0 0h24v24H0V0z" />
        <path d="M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z" />
      </svg>
      <p  className='f-size'>
        Players are requested not to contact any untrusted sources for Khatri555
        accounts.
      </p>
    </span>
  </div>
      <Footer/>
    </div>
  )
}

export default AboutUs